.wrap {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 24px;
  background: var(--canvas);
}

.card {
  max-width: 420px;
  width: 100%;
  text-align: center;
  background: var(--surface);
  border-radius: var(--radius);
  padding: 32px 28px;
}

.title {
  margin: 0 0 12px;
  font-family: var(--font-display);
  font-size: 24px;
  font-weight: 700;
  color: var(--text);
}

.body {
  margin: 0 0 24px;
  color: var(--soft);
  font-size: 15px;
  line-height: 1.5;
}

.button {
  background: var(--amber);
  color: #262119;
  font-size: 15px;
  font-weight: 700;
  padding: 10px 20px;
  border-radius: var(--radius-sm);
  cursor: pointer;
}

.button:hover {
  opacity: 0.88;
}
